export default "__VITE_ASSET__CgKZzYM___"